import Vue from 'vue';
import Vuex from 'vuex';
import {getLocal} from '../assets/js/utils'
Vue.use(Vuex);

const state={
    menuList: [],//全部菜单
    leftMemuList:[],//左菜单
    logo:getLocal('oaLogo')||require('../assets/images/logo.png'),
    checkInTab:'',//考勤tab切换,
    leftMenuFlag:true,
    tagFlag:false,
    //baseURL:'http://noa.cisdom.com.cn/inter/',
    // baseURL:'http://192.168.50.41:8080/',
    //baseURL:'http://192.168.50.22:8080/',
     baseURL:'http://192.168.50.25:7085/',
};
const getters = {
    getMenu(state) {
        return state.menuList
    },
    getLeftMenu(){
        return state.leftMemuList
    },
    getLogo(){
        return state.logo
    },
    getLeftMenuFlag(state){
        return state.leftMenuFlag
    },
    getTagFlag(state){
        return state.tagFlag
    }
    
};
const mutations = {
    setMenu(state,list) { 
        state.menuList = list;
    },
    setLeftMenu(state,list) { 
        state.leftMemuList = list;
    },
    setLogo(state,url) { 
        state.logo = url;
    },
    setCheckInTab(state,data){
        state.checkInTab = data;
    },
    changeMenuFlag(state,data){
        state.leftMenuFlag = data;
    },
    setTagFlag(state,data){
        state.tagFlag = data;
    }
    
};

const store = new Vuex.Store({
    state,
    getters,
    mutations,

});

export default store;


// WEBPACK FOOTER //
// ./src/vuex/store.js